import React from 'react';
import { Translate } from 'react-jhipster';
import MenuItem from 'app/shared/layout/menus/menu-item';

const EntitiesMenu = () => {
  return (
    <>
      {/* prettier-ignore */}
      {/* <MenuItem icon="asterisk" to="/fact-checking">
        <Translate contentKey="global.menu.entities.factChecking" />
      </MenuItem> */}
      <MenuItem icon="asterisk" to="/user-extra">
        <Translate contentKey="global.menu.entities.userExtra" />
      </MenuItem>
      <MenuItem icon="asterisk" to="/foreigner-residence">
        <Translate contentKey="global.menu.entities.foreignerResidence" />
      </MenuItem>
      {/* jhipster-needle-add-entity-to-menu - JHipster will add entities to the menu here */}
    </>
  );
};

export default EntitiesMenu;
